export interface TelemetryRuntime {
	enable(): void
	disable(): void
	log(message: string): void
	error(error: Error): void
}

// Read effective consent, not the event's payload: regional defaults and later
// preference changes are both owned by the existing consent orchestrator.
export function manageTelemetryConsent(options: {
	allowed: () => boolean | undefined
	subscribe: (refresh: () => void) => () => void
	load: () => Promise<TelemetryRuntime>
}) {
	let runtime: TelemetryRuntime | undefined
	let loading = false
	let enabled = false
	let disposed = false
	const allowed = () => !disposed && options.allowed() === true
	const refresh = () => {
		if (!allowed()) {
			runtime?.disable()
			enabled = false
			return
		}
		if (runtime) {
			if (!enabled) { runtime.enable(); enabled = true }
			return
		}
		if (loading) return
		loading = true
		void options.load().then((loaded) => {
			runtime = loaded
			if (allowed()) { runtime.enable(); enabled = true }
			else runtime.disable()
		}).catch(() => {
			// An unavailable collector/SDK must never break the storefront.
		}).finally(() => { loading = false })
	}
	const unsubscribe = options.subscribe(refresh)
	refresh()
	return {
		log: (message: string) => { if (allowed() && enabled) runtime?.log(message) },
		error: (error: Error) => { if (allowed() && enabled) runtime?.error(error) },
		dispose: () => { disposed = true; unsubscribe(); runtime?.disable() },
	}
}
